"use strict";
/**
 * Visibility Engine — sl-ngy4.4.3.
 *
 * Pure evaluator for `VisibilityRule`. A slot is visible when:
 *   - no rule is attached, OR
 *   - all present operators evaluate to true (AND-combined).
 *
 * Operators are read from the VisibilityRule interface (slot.ts):
 *   - `equals` — strict equality against `values[rule.field]`
 *   - `in`     — membership check with strict equality per element
 *   - `not`    — negated strict equality
 *
 * No React imports, no side-effects. The panel renderer calls this before
 * mounting the slot editor, and the same function is called by vitest
 * suites to lock in the semantics.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateVisibility = evaluateVisibility;
function evaluateVisibility(rule, values) {
    if (!rule)
        return true;
    const v = values[rule.field];
    if (rule.equals !== undefined && v !== rule.equals)
        return false;
    if (rule.in !== undefined && !rule.in.includes(v))
        return false;
    if (rule.not !== undefined && v === rule.not)
        return false;
    return true;
}
